import React, { useContext, useEffect, useState } from 'react';
import ContainerPage from '../../../components/ContainerPage/ContainerPage';
import { getCustomerOrders } from '../../../http/ordersAPI';
import Order from './Order/Order';
import { AuthContext } from '../../../context/AuthContext';
import styles from './OrdersCustomer.module.scss';

const OrdersCustomer = () => {
  const admin = useContext(AuthContext).permissions?.admin?.access;
  const [orders, setOrders] = useState();

  useEffect(() => {
    getCustomerOrders(admin).then(res => {
      if (res.data.length === 0) {
        setOrders(null);
      } else {
        setOrders(res.data);
      }
    });
  }, []);

  const ordersList = orders ? (
    orders.map(order => {
      return (
        <li key={order.orderNo}>
          <Order order={order} />
        </li>
      );
    }).reverse()
  ) : (
    <div>У вас поки замовлень немає</div>
  );

  return (
    <ContainerPage>
      <div className={styles.list}>
        <div>
          <h2>Ваші замовлення</h2>
        </div>

        <ul>{ordersList}</ul>
      </div>
    </ContainerPage>
  );
};

export default OrdersCustomer;
